import axios from "@/utils/axiosInterceptors";
import { getApiV3WithDivision } from "@/utils/apiBisomV3";

import config from "@/config/env";
import { apiHeader } from "@bisom/web_package";

// Types
import type { Article } from "@/types/news";

const apiEndPoint = async () => {
  const apiV3 = await getApiV3WithDivision();
  return `${apiV3}/users/freshdesk_token`;
};

const getToken = async () => {
  try {
    const params: object = {
      ...apiHeader(),
    };
    const url = await apiEndPoint();

    const response = (await axios.get(url, params)) as {
      data: { freshworks_widget_auth_token: string };
    };

    FreshworksWidget("authenticate", {
      token: response.data.freshworks_widget_auth_token,
    });

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

const getArticles = async (freshdeskApiKey: string) => {
  try {
    const params: object = {
      headers: { Authorization: `Basic ${freshdeskApiKey}` },
      params: { per_page: 5 },
    };
    const url = `${config.freshdesk_folders_api_url}/${config.freshdesk_folder_id}/articles`;

    const response = await axios.get(url, params);
    return Promise.resolve(response.data as Article[]);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getArticles,
  getToken,
};
